import { useLocation } from "react-router"
import { Button } from "../button/button";
import { ArrowIcon } from "../../assets/icons";
import { useAnimatedNavigate } from "../../hooks/useAnimatedNavigate";
import { useMemo } from "react";

export const BackButton = ({ minPathnameLength = 2, stopRoutes = [] }) => {
    const { pathname, search } = useLocation();

    const parts = useMemo(() => pathname.split("/"), [pathname]);

    const navigate = useAnimatedNavigate();
    const handleClick = () => {
        const newPath = [...parts];
        newPath.pop();

        if (stopRoutes.includes(newPath.at(-1))) {
            newPath.pop();
        }

        navigate(newPath.join("/") + (search || ""));
    }

    return (
        <Button
            text="Назад"
            view="thin"
            style={{
                display: (parts.length <= minPathnameLength) ? "none" : undefined,
                width: "auto",
                alignSelf: "start"
            }}
            before={<ArrowIcon angle={180} />}
            onClick={handleClick}
            type="secondary"
        />
    );
}